//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import React from 'react';
import styled from 'styled-components';

//  -- Components ---------------------
import { Button, Modal } from '@mui/material';

//  -- Constants ----------------------
import COLOR from 'utils/constants/color';


//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
export const Wrapper = styled.div`
    align-items: center;
    background-color: ${COLOR.white};
    border-radius: 3px;
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    padding: 16px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
`;


//  ----------------------------------------------------------------------------
//  Component
//  ----------------------------------------------------------------------------
//
//  Demo modal
//
//  -- Description
//  Demo modal indicator for demo accounts
//
//  -- Props
//  handleClose: func - Function to handle modal close
//  open: bool - Whether the modal is open
//  message: string - Custom message to display (optional)
//
const DemoModal = ({
    handleClose,
    open = false,
    message = 'This is a demo account, please contact One Way Education',
}) => {
    return (
        <Modal
            open={open}
            onClose={handleClose}
        >
            <Wrapper>
                {message}
                <Button
                    onClick={handleClose}
                    variant="contained"
                    color="secondary"
                    style={{ marginTop: '8px' }}
                >
                    Close
                </Button>
            </Wrapper>
        </Modal>
    );
};

export default DemoModal;
